/**
 *
 *
 *
 *
 */
import {
    EXPERIMENTS,
    type ExperimentConfigs,
    type ExperimentGroups,
    type ExperimentId,
    type OnexAssignments,
} from '@tilelist/domain/experiments/Experiments.ts';
import type { OnEx, OnExServerData } from '@tilelist/domain/experiments/OnEx.ts';
import { type ToggleName, type Toggles, defaultToggles } from '@tilelist/domain/experiments/Toggles.ts';

export type { OnexAssignments } from '@tilelist/domain/experiments/Experiments.ts';

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export class OnExAdapter implements OnEx, OnExServerData {
    constructor(
        readonly onexAssignments: OnexAssignments,
        readonly toggles: Toggles,
        readonly configs: ExperimentConfigs = EXPERIMENTS,
    ) {}

    static fromServer({ onexAssignments, toggles, configs }: OnExServerData): OnExAdapter {
        return new OnExAdapter(onexAssignments, toggles, configs);
    }

    /**
 *
 */
    isToggleActive(toggleName: ToggleName): boolean {
        return this.toggles[toggleName];
    }

    /**
 *
 */
    isExperimentActive<E extends ExperimentId>(experimentId: E) {
        const onexId = this.configs[experimentId].onexExperimentId;
        return onexId in this.onexAssignments;
    }

    /**
 *
 */
    getExperimentGroup<E extends ExperimentId>(experimentId: E): ExperimentGroups[E] {
        const config = this.configs[experimentId];

        /*                                                       */
        if (this.toggles[config.featureToggle]) {
            return config.featureOnGroup;
        }

        /*                                                                       */
        if (this.toggles[config.experimentToggle]) {
            const onexId = config.onexExperimentId;
            const onexGroup = this.onexAssignments[onexId];
            if (this.isValidOnexGroup(experimentId, onexGroup)) {
                return onexGroup;
            }
        }

        /*                                                                              */
        return config.defaultGroup;
    }

    /**
 *
 */
    isExperimentGroup<E extends ExperimentId>(experimentId: E, group: ExperimentGroups[E]): boolean {
        return this.getExperimentGroup(experimentId) === group;
    }

    /**
 *
 */
    mapGroup<E extends ExperimentId, T>(experimentId: E, mapping: (group: ExperimentGroups[E]) => T): T {
        return mapping(this.getExperimentGroup(experimentId));
    }

    /**
 *
 *
 */
    matchGroup<E extends ExperimentId, T>(experimentId: E, mapping: Record<ExperimentGroups[E], T>): T {
        const group = this.getExperimentGroup(experimentId);
        return mapping[group];
    }

    /**
 *
 */
    private isValidOnexGroup<E extends ExperimentId>(
        experimentId: E,
        group: OnexAssignments[keyof OnexAssignments] | undefined,
    ): group is ExperimentGroups[E] {
        if (group === undefined) {
            return false;
        }

        const config = this.configs[experimentId];
        return config.groups.some((validGroup) => validGroup === group);
    }
}

/**
 *
 */
export const DEFAULT_ONEX: OnEx & OnExServerData = new OnExAdapter({}, defaultToggles);
